var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscomfort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00c769;}.cls-6{fill:#00ad5b;}.cls-7{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1024.3,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.1c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8,610.7,610.7,0,0,0-87.9,316.7c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.1,1291.5,1551.1,1068.5,1551.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,410.6A610.4,610.4,0,0,0,659.9,531a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,685.4,1363.9,410.6,1025,410.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1039.5,
    cy: 558.6,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(79 1244.2) rotate(-63.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.3 1428.6) rotate(-60)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1025,
    cy: 1025.7,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1025,1409.5c-299.6,0-549.1-214.8-602.9-498.8a614.2,614.2,0,0,0-10.8,115c0,338.9,274.8,613.7,613.7,613.7s613.7-274.8,613.7-613.7a614.2,614.2,0,0,0-10.8-115C1574.1,1194.7,1324.6,1409.5,1025,1409.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1256.8,1151.8a30.2,30.2,0,0,1-14.7-3.9c-70.8-39.7-143.9-59.8-217.1-59.8s-146.3,20.1-217.1,59.8a30,30,0,0,1-29.4-52.3c80-44.8,162.9-67.5,246.5-67.5s166.5,22.7,246.5,67.5a30.1,30.1,0,0,1-14.7,56.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M640.8,844.4a30,30,0,0,1-7-59.2,298.3,298.3,0,0,0,61-23.8c26.3-13.8,59.7-37.3,69.7-70.5A30,30,0,1,1,822,708.1c-12.8,42.5-47.6,79.6-100.6,107.1a349.9,349.9,0,0,1-73.6,28.3A28.6,28.6,0,0,1,640.8,844.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1409.2,844.4a28.6,28.6,0,0,1-7-.9,349.9,349.9,0,0,1-73.6-28.3c-53-27.5-87.8-64.6-100.6-107.1a30,30,0,1,1,57.5-17.2c19.8,66.1,129.6,94,130.7,94.3a30,30,0,0,1-7,59.2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 760.6,
    cy: 824.3,
    rx: 58.9,
    ry: 67.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 785.1,
    cy: 814.3,
    r: 18.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1274,
    cy: 824.3,
    rx: 58.9,
    ry: 67.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1256.8,
    cy: 814.3,
    r: 18.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M803.7,1215.8a30.1,30.1,0,0,1-30-30,97.5,97.5,0,0,0-52.3-86.6,30,30,0,1,1,27.8-53.1,157.1,157.1,0,0,1,84.5,139.7A30,30,0,0,1,803.7,1215.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1246.3,1215.8a30,30,0,0,1-30-30,157.1,157.1,0,0,1,84.5-139.7,30,30,0,1,1,27.8,53.1,97.5,97.5,0,0,0-52.3,86.6A30.1,30.1,0,0,1,1246.3,1215.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1025,
    cy: 1184.7,
    rx: 94.5,
    ry: 11.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscomfort);
export default __webpack_public_path__ + "static/media/discomfort.0694bdd351c2127e2a2ab19950b68b18.svg";
export { ForwardRef as ReactComponent };